import { render, staticRenderFns } from "./DashboardOther.vue?vue&type=template&id=2d994585&"
import script from "./DashboardOther.vue?vue&type=script&lang=js&"
export * from "./DashboardOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports